import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../components/Layout";
import { logPv } from "@/utils/log";
// import store from "@/store";
// import { loadLanguageAsync } from "@/utils/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Layout,
    // redirect: "/home",
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: "/",
        name: "homeIndex",
        component: () => import("../views/home"),
        meta: {
          keepAlive: true
        }
      },
      {
        path: "/my-list",
        name: "myList",
        component: () => import("../views/myList"),
        meta: {
          keepAlive: true
        }
      },
      {
        path: "/my",
        name: "my",
        component: () => import("../views/my"),
        meta: {
          keepAlive: true
        }
      },
    ],
  },

  {
    path: "/history",
    name: "history",
    component: () => import("../views/history"),
  },

  {
    path: "/player/:bookId/:chapterId",
    name: "player",
    component: () => import("../views/player"),
  },

  {
    path: "/contact-us",
    name: "contactUs",
    component: () => import("../views/my/ContactUs"),
  },

  {
    path: "/unlock-history",
    name: "unlockHistory",
    component: () => import("../views/my/UnlockHistory"),
  },

  {
    path: "/search",
    name: "search",
    component: () => import("../views/search"),
  },

  {
    path: "/lang",
    name: "lang",
    component: () => import("../views/my/Lang"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/my/Privacy"),
  },
  {
    path: "/privacy-hk",
    name: "privacyHK",
    component: () => import("../views/my/PrivacyHK"),
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  try {
    // const lang = store.state.common.lang
    // loadLanguageAsync(lang).finally(() => next())
    logPv({
      prev: from.name,
      ptype: to.name,
    })
    next()
  } catch (error) {
    console.error(error)
    next()
  }
})

export default router;
